<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['welcome'],
      }"
      @click="configMainShow['welcome'] = !configMainShow['welcome']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>来宾欢迎</span>
        <span
          class="el-switch"
          @click.stop="toggleEnable('welcome', '来宾欢迎')"
        >
          <el-switch v-model="configure.welcome.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['welcome'].timeRemaining)
          ? shoWDialogBuy(
              featureList['welcome']['productKey'],
              '基础包',
              'welcome'
            )
          : featureList['welcome'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.welcome.enable
          ? ''
          : toggleEnable('welcome', '来宾欢迎')
      "
      :class="{
        'no-buy': isNaN(featureList['welcome'].timeRemaining),
        expired: featureList['welcome'].timeRemaining <= 0,
        'shut-off': !configure.welcome.enable,
      }"
    >
      <el-row>
        <el-col :span="5">一般来宾</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-checkbox-group
              v-model="configure.welcome.welcome1.level"
              @change="welcome1Change"
            >
              <el-checkbox
                :label="item.value"
                v-for="item in welcomeConfig"
                :key="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">重要来宾</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-checkbox-group
              v-model="configure.welcome.welcome2.level"
              @change="welcome2Change"
            >
              <el-checkbox
                :label="item.value"
                v-for="item in welcomeConfig"
                :key="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">白号</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-checkbox-group v-model="whiteidCon" @change="whiteidConChange">
              <el-checkbox label="welcomeHasBadge">有牌贵宾席白号</el-checkbox>
              <el-checkbox label="welcomeNoBadge">无牌贵宾席白号</el-checkbox>
              <!-- :disabled="
                  !accountList[ticket] ||
                    (accountList[ticket] &&
                      accountList[ticket].user.accountType != 1)
                " -->
              <el-checkbox
                label="welcomeTourist"
                v-if="whiteidEnable"
                >游客白号<a
                  href="//www.xiaohudi.com/entry/2.html"
                  target="_blank"
                  style="margin-left: 10px"
                  ><i class="fa-question-circle"></i></a
              ></el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">
          一般来宾
          <br />句式池
          <div class="tips" v-if="whiteidEnable">(白号归入此池)</div>
        </el-col>
        <el-col :span="19">
          <div class="sentence-list">
            <div class="block-tag">
              随机发送下列句式，点击可编辑，也可自行添加。
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.welcome.welcome1.tpl"
                :key="index"
              >
                <Editor
                  v-model="configure.welcome.welcome1.tpl[index]"
                  :labels="['userNick', 'anchorNick']"
                  @input="checkEmpty(configure.welcome.welcome1.tpl, index)"
                ></Editor>
                <i class="fa-window-close" @click="removeWelcome(index)"></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addWelcome1')"
            @focusout="singleInputFocusOut('addWelcome1')"
          >
            <Editor
              v-model.trim="addWelcome1"
              mode="edit"
              :labels="['userNick', 'anchorNick']"
            ></Editor>
            <el-popover
              ref="addWelcome1"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addWelcome1"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addWelcome1Tpl"
              v-popover:addWelcome1
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          重要来宾
          <br />句式池
          <div class="tips">(大哥归入此池)</div>
        </el-col>
        <el-col :span="19">
          <div class="sentence-list">
            <div class="block-tag">
              随机发送下列句式，可以点击编辑或删除，也可自定义添加。
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.welcome.welcome2.tpl"
                :key="index"
              >
                <Editor
                  v-model="configure.welcome.welcome2.tpl[index]"
                  @input="checkEmpty(configure.welcome.welcome2.tpl, index)"
                  :labels="['userNick', 'anchorNick']"
                ></Editor>
                <i class="fa-window-close" @click="removeWelcome2(index)"></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addWelcome2')"
            @focusout="singleInputFocusOut('addWelcome2')"
          >
            <Editor
              v-model.trim="addWelcome2"
              mode="edit"
              :labels="['userNick', 'anchorNick']"
            ></Editor>
            <el-popover
              ref="addWelcome2"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addWelcome2"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addWelcome2Tpl"
              v-popover:addWelcome2
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">打卡</el-col>
        <el-col :span="19">
          <div class="block-tag warning">
            打卡欢迎话术，在启动5分钟后生效
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.signIn.enable"
              @change="signInEnableChange"
            ></el-switch>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">欢迎句式</el-col>
        <el-col :span="19">
          <div>
            <ul>
              <li>
                <Editor
                  v-model="configure.signIn.tpl"
                  :labels="['userNick', 'anchorNick', 'checkInDays']"
                ></Editor>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">进入名单条件</el-col>
        <el-col :span="19">
          <div class="block-tag">
            打卡名单最多1000个，请设置进入名单的送礼条件。
          </div>
          <div>
            <el-select
              v-model="configure.signIn.giftCondition.giftId"
              @change="giftConditionByGiftChange"
              size="mini"
              placeholder="请选择"
            >
              <el-option-group
                v-for="group in giftSelectOptions"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="(groupitem, index) in group.options"
                  :key="index"
                  :label="groupitem.label"
                  :value="groupitem.id"
                ></el-option>
              </el-option-group>
            </el-select>
            <el-input-number
              v-model="configure.signIn.giftCondition.giftCount"
              :controls-position="isPC ? 'right' : ''"
              :min="1"
              size="mini"
              :precision="0"
            ></el-input-number
            >个
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">打卡条件</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-radio-group v-model="configure.signIn.signCondition.free">
              <el-radio :label="true" style="margin-right: 10px;"
                >免费打卡</el-radio
              >
              <el-radio :label="false">礼物打卡</el-radio>
            </el-radio-group>
          </div>
          <div v-if="!configure.signIn.signCondition.free" class="row-padding">
            <el-select
              v-model="configure.signIn.signCondition.giftId"
              @change="giftSignConditionByGiftChange"
              size="mini"
              placeholder="请选择"
            >
              <el-option-group
                v-for="group in giftSelectOptions"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="(groupitem, index) in group.options"
                  :key="index"
                  :label="groupitem.label"
                  :value="groupitem.id"
                ></el-option>
              </el-option-group>
            </el-select>
            <el-input-number
              v-model="configure.signIn.signCondition.giftCount"
              :controls-position="isPC ? 'right' : ''"
              :min="1"
              size="mini"
              :precision="0"
            ></el-input-number
            >个
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">打卡名单</el-col>
        <el-col :span="19">
          <div class="search-container" @click.stop>
            <div class="search-input">
              <el-input
                class="inline-input"
                prefix-icon="el-icon-search"
                v-model.trim="nickname"
                placeholder="请输入想搜索的昵称..."
                @input="searchInput"
              >
              </el-input>
            </div>
            <div class="form-body">
              <ul class="audience-list" v-show="showAudienceList.length">
                <li v-for="(item, index) in showAudienceList" :key="index">
                  <div class="user-info">
                    <div class="avatar-box">
                      <img class="avatar" :src="item.avatar" alt="" />
                      <span
                        v-if="item.nobleLevel"
                        class="noble-icon"
                        :class="`noble-level-${item.nobleLevel}`"
                      ></span>
                    </div>
                    <span class="name">{{ item.nickname }}</span>
                    <span
                      v-if="item.level"
                      class="level-icon"
                      :class="`level-icon${item.level}`"
                    ></span>
                    <!-- <span class="fans-icon" :class="`lv${item.fansLevel}`">{{
                      item.badgeName
                    }}</span>
                    <span
                      class="guard-icon"
                      :class="`v${item.guardLevel}`"
                    ></span> -->
                    <span class="days">
                      <span>(打卡</span>
                      {{ item.day }}
                      <span>天)</span>
                    </span>
                  </div>
                  <i
                    class="fa-window-close"
                    @click="delSignInListItem(index)"
                  ></i>
                </li>
              </ul>
              <div class="no-data" v-show="!showAudienceList.length">
                暂无数据
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row
        v-if="
            featureList['bigData'].timeRemaining > 0
        "
      >
        <el-col :span="5">
          消费档暗号：
          <span id="welcomeBigData" class="hide-anchor-point"></span>
        </el-col>
        <el-col :span="19">
          <div class="block-tag warning"  v-if="
              isNaN(featureList['bigData'].timeRemaining) ||
                featureList['bigData'].timeRemaining <= 0
            ">
            近期消费能力需要「大数据」功能支持。
            <el-link
              class="block-tag-link"
              type="primary"
              :underline="false"
              @click="
                shoWDialogBuy(
                  featureList['bigData']['productKey'],
                  '大数据',
                  'bigData'
                )
              "
              >立即开通</el-link
            >
          </div>
          <div
            class="code-list big-data-modules"
            @click="
              isNaN(featureList['bigData'].timeRemaining)
                ? shoWDialogBuy(
                    featureList['bigData']['productKey'],
                    '大数据',
                    'bigData'
                  )
                : featureList['bigData'].timeRemaining <= 0
                ? showFunctionalRenewal(true)
                : configure.bigData.enable
                ? ''
                : toggleEnable('bigData', '大数据')
            "
            :class="{
              'no-buy': isNaN(featureList['bigData'].timeRemaining),
              expired: featureList['bigData'].timeRemaining <= 0,
              'shut-off': !configure.bigData.enable,
            }"
          >
            <div class="list-header">
              <div class="gear-title">档位名称</div>
              <div class="gear-code">档位暗号</div>
            </div>
            <div class="list-body">
              <div
                class="list-item"
                v-for="item in configure.welcome.newConsumeAbility"
                :key="item.money"
              >
                <div class="gear-title">
                  <el-switch v-model="item.enable"></el-switch
                  >{{ consumeLevel[item.money] }}
                </div>
                <div class="gear-code">
                  <input v-model="item.mark" placeholder="请输入暗号" />
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        v-if="
            featureList['bigData'].timeRemaining > 0
        "
      >
        <el-col :span="5">
          消费档暗号
          <br />句式池
        </el-col>
        <el-col
          :span="19"
          class="big-data-modules"
          @click="
            isNaN(featureList['bigData'].timeRemaining)
              ? shoWDialogBuy(
                  featureList['bigData']['productKey'],
                  '大数据',
                  'bigData'
                )
              : featureList['bigData'].timeRemaining <= 0
              ? showFunctionalRenewal(true)
              : configure.bigData.enable
              ? ''
              : toggleEnable('bigData', '大数据')
          "
          :class="{
            'no-buy': isNaN(featureList['bigData'].timeRemaining),
            expired: featureList['bigData'].timeRemaining <= 0,
            'shut-off': !configure.bigData.enable,
          }"
        >
          <div class="sentence-list">
            <div class="block-tag">
              随机发送下列句式，可以点击编辑或删除，也可自定义添加。
            </div>
            <ul>
              <li
                v-for="(item, index) in configure.welcome.welcomeConsumeTpls"
                :key="index"
              >
                <Editor
                  v-model="configure.welcome.welcomeConsumeTpls[index]"
                  @input="
                    checkEmpty(configure.welcome.welcomeConsumeTpls, index)
                  "
                  :labels="['userNick', 'anchorNick', 'consumeSignal']"
                ></Editor>
                <i
                  class="fa-window-close"
                  @click="removeWelcomeConsumeTpls(index)"
                ></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addWelcomeConsume')"
            @focusout="singleInputFocusOut('addWelcomeConsume')"
          >
            <Editor
              v-model.trim="addWelcomeConsume"
              mode="edit"
              :labels="['userNick', 'anchorNick', 'consumeSignal']"
            ></Editor>
            <el-popover
              ref="addWelcomeConsume"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addWelcomeConsume"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addWelcomeConsumeTpl"
              v-popover:addWelcomeConsume
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">其他设置</el-col>
        <el-col :span="19">
          <el-switch v-model="configure.welcome.repetitionEnable"></el-switch>
          <el-input-number
            v-model="configure.welcome.welcomeRepetition"
            :controls-position="isPC ? 'right' : ''"
            size="mini"
          ></el-input-number
          >分钟内进房间不重复欢迎
          <div class="row-padding">
            <el-switch
              v-model="configure.welcome.welcomeEndorsementGroupEnable"
            ></el-switch
            >欢迎带盐团
          </div>
          <div
            class="row-padding"
            v-show="configure.welcome.welcomeEndorsementGroupEnable"
          >
            <div>
              <ul>
                <li>
                  <Editor
                    v-model="configure.welcome.welcomeEndorsementGroupText"
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('来宾欢迎', 'welcome')"
          >「来宾欢迎」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
import { getSignUserList, signUserBan } from "@/api";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      //欢迎设定配置项
      welcomeConfig: require("@/assets/js/welcomeConfig.json"),
      // 小白号配置
      whiteidCon: [],
      addWelcome1: "", // 欢迎 一般来宾 句式输入框
      addWelcome2: "", // 欢迎 贵重来宾 句式输入框
      addWelcomeConsume: "", // 消费档暗号 句式输入框
      consumeLevel: {
        1: "一元档",
        10: "十元档",
        100: "百元档",
        1000: "千元档",
        10000: "万元档",
        50000: "五万档",
        100000: "十万档",
        1000000: "百万档",
        10000000: "千万档",
      },
      totalAudienceList: [],
      showAudienceList: [],
      nickname: "",
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    accountList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    ticket: {
      type: String,
      default: "",
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
    giftSelectOptions: {
      type: Array,
      default: require("@/assets/js/giftSelectOptions.json"),
    },
  },
  mounted() {
    this.whiteidConFormat();
    this.getAudienceList();
  },
  methods: {
    welcome1Change(val) {
      this.configure.welcome.welcome1.level.forEach((val, index) => {
        this.configure.welcome.welcome2.level.forEach((ele, index) => {
          if (val == ele) {
            this.configure.welcome.welcome2.level.splice(index, 1);
          }
        });
      });
      this.configure.welcome.welcome1.level.sort();
      this.configure.welcome.welcome2.level.sort();
    }, // 互斥功能

    welcome2Change(val) {
      this.configure.welcome.welcome2.level.forEach((val, index) => {
        this.configure.welcome.welcome1.level.forEach((ele, index) => {
          if (val == ele) {
            this.configure.welcome.welcome1.level.splice(index, 1);
          }
        });
      });
      this.configure.welcome.welcome1.level.sort();
      this.configure.welcome.welcome2.level.sort();
    }, // 互斥功能
    whiteidConChange(val) {
      this.configure.welcome.welcomeNoBadge = !!~val.indexOf("welcomeNoBadge");
      this.configure.welcome.welcomeTourist = !!~val.indexOf("welcomeTourist");
      this.configure.welcome.welcomeHasBadge = !!~val.indexOf(
        "welcomeHasBadge"
      );
    }, //小白号选择
    removeWelcome(index) {
      this.configure.welcome.welcome1.tpl.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除一般来宾句式
    removeWelcome2(index) {
      this.configure.welcome.welcome2.tpl.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除重点来宾句式
    removeWelcomeConsumeTpls(index) {
      this.configure.welcome.welcomeConsumeTpls.splice(index, 1);
      this.$message.success("删除成功");
    }, //删除消费档暗号句式
    addWelcome1Tpl() {
      if (this.addWelcome1 === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.welcome.welcome1.tpl.unshift(this.addWelcome1);
        this.addWelcome1 = "";
        this.$message.success("添加成功");
      }
    }, // 一般来宾欢迎语句添加
    addWelcome2Tpl() {
      if (this.addWelcome2 === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.welcome.welcome2.tpl.unshift(this.addWelcome2);
        this.addWelcome2 = "";
        this.$message.success("添加成功");
      }
    },
    addWelcomeConsumeTpl() {
      if (this.addWelcomeConsume === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.welcome.welcomeConsumeTpls.unshift(
          this.addWelcomeConsume
        );
        this.addWelcomeConsume = "";
        this.$message.success("添加成功");
      }
    },
    whiteidConFormat() {
      if (this.configure.welcome.welcomeNoBadge) {
        this.whiteidCon.push("welcomeNoBadge");
      }
      if (this.configure.welcome.welcomeTourist) {
        this.whiteidCon.push("welcomeTourist");
      }
      if (this.configure.welcome.welcomeHasBadge) {
        this.whiteidCon.push("welcomeHasBadge");
      }
    },
    getAudienceList() {
      getSignUserList({
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0 && res.data.list) {
          this.totalAudienceList = res.data.list || [];
          this.showAudienceList = res.data.list || [];
          this.configure.signIn.listLength = res.data.list.length || 0;
        } else {
          this.totalAudienceList = [];
          this.showAudienceList = [];
          this.configure.signIn.listLength = 0;
        }
        this.$emit("listLengthSave");
      });
      // let list = [
      //   {
      //     nickname: "孤身",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "大猫",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "胖虎",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "二狗",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "叶天",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "孤身",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "孤身",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "孤身",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "孤身",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "孤身",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      //   {
      //     nickname: "孤身",
      //     nobleLevel: 1,
      //     level: 15,
      //     fansLevel: 20,
      //     badgeName: "胖虎",
      //     guardLevel: 1,
      //     day: 6,
      //   },
      // ];
    },
    signInEnableChange(val) {
      console.log(val);
      if (!val && this.configure.signIn.listLength) {
        this.$confirm("关闭开关后，原打卡记录将清除", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.signInStatusChange();
          })
          .catch(() => {
            this.configure.signIn.enable = true;
          });
      }
    },
    signInStatusChange() {
      this.totalAudienceList = [];
      this.showAudienceList = [];
      this.configure.signIn.listLength = 0;
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.nickname.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
        );
      };
    },
    searchInput() {
      let restaurants = this.totalAudienceList;
      let results = this.nickname
        ? restaurants.filter(this.createStateFilter(this.nickname))
        : restaurants;
      this.showAudienceList = results;
    },
    giftConditionByGiftChange(e) {
      let index = this.giftSelectOptions[0].options.findIndex((val) => {
        return val.id == e;
      });
      this.configure.signIn.giftCondition.giftName = this.giftSelectOptions[0].options[
        index
      ].label;
    },
    giftSignConditionByGiftChange(e) {
      let index = this.giftSelectOptions[0].options.findIndex((val) => {
        return val.id == e;
      });
      this.configure.signIn.signCondition.giftName = this.giftSelectOptions[0].options[
        index
      ].label;
    },
    delSignInListItem(index) {
      this.$confirm(
        `确定将“${this.showAudienceList[index].nickname}”移出打卡名单吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          signUserBan({
            ticket: this.ticket,
            uid: this.showAudienceList[index].uid,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "success",
                message: "删除成功",
              });
              this.showAudienceList.splice(index, 1);
            } else {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message: res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.tips {
  font-size: 14px;
  color: #c6c6c6;
}
.form-body {
  position: relative;
  height: 350px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  margin-top: 10px;
  li {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: top;
    padding: 10px 30px 10px 10px;
    margin: 0 10px;
    border-bottom: 1px dashed #e6e6e6;
    &:last-child {
      border-bottom: none;
    }
    .user-info {
      font-size: 16px;
      .avatar-box {
        display: inline-block;
        position: relative;
        width: 40px;
        height: 40px;
        vertical-align: middle;
        margin-right: 10px;
        .avatar {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .noble-icon {
          position: absolute;
          right: -6px;
          bottom: -4px;
          margin: 0;
        }
      }
      .name {
        margin: 0 5px;
        vertical-align: middle;
      }
      span {
        margin: 0 5px;
        cursor: default;
      }
      .days {
        white-space: nowrap;
        span {
          color: #ccc;
          font-size: 12px;
        }
      }
    }
    .fa-window-close {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      cursor: pointer;
      color: #c8c8c8;
      &:hover {
        color: #000;
      }
    }
  }
  .no-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    color: #000;
  }
}
.code-list {
  height: 360px;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
  .list-header {
    display: flex;
    background: #f4f4f4;
    border-radius: 6px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    line-height: 38px;
    font-size: 14px;
    color: #101010;
  }
  .list-body {
    .list-item {
      display: flex;
      line-height: 30px;
      font-size: 14px;
    }
  }
  .gear-title {
    flex: 1.5;
    text-align: center;
    @media (max-width: 960px) {
      flex: 2.5;
    }
    @media (max-width: 320px) {
      min-width: 120px;
    }
  }
  .gear-code {
    flex: 4;
    text-align: left;
    padding-left: 20px;
  }
}
</style>
